export default {
  navHome: "Главная",
  navProducts: "Продукция",
  navCases: "Примеры применения",
  navAbout: "О компании",
  deliverTo: "Доставка в:",
  langCurrencyLabel: "Русский",
  localeLangTitle: "Настройка языка",
  localeLangDesc:
    "Выберите предпочитаемый язык. Вы можете изменить эту настройку в любое время.",
  language: "Язык",
  save: "Сохранить",
  coreProducts: "Воплощение творчества в реальном мире.",
  coreProductsDesc:
    "От идеи к бизнесу �?YONGYUAN предлагает УФ-принтеры, принтеры кристаллических этикеток, высокоскоростные цилиндрические принтеры, DTF и DTG принтеры, превращая творчество в продукты, бренды и возможности.",
  scenariosTitle: "Решения для каждого сценария",
  scenariosDesc:
    "Создаёте ли вы бренд, развиваете дополнительный бизнес или следуете творческим увлечениям �?YONGYUAN предлагает решение, адаптированное к вашим потребностям.",
  scenarioStudio: "Студия",
  scenarioStudioDesc:
    "Высокоценная персонализация, мелкосерийное прототипирование и построение бренда",
  scenarioRetail: "Брендовый ритейл",
  scenarioRetailDesc:
    "Увеличение времени пребывания клиентов и доходов магазина",
  scenarioMarket: "Уличный рынок",
  scenarioMarketDesc:
    "Персонализация на месте, продажа готовой продукции и дополнительный доход",
  scenarioEnterprise: "Корпоративная персонализация",
  scenarioEnterpriseDesc:
    "Серийная персонализация, брендированный мерч и корпоративные подарки",
  scenarioEcommerce: "Продажи в прямом эфире",
  scenarioEcommerceDesc:
    "Образцы хитов, гибкие поставки и быстрые запуски продуктов",
  scenarioStore: "Интернет-магазин",
  scenarioStoreDesc:
    "Персонализация магазина, хитовый мерч и дифференцированные операции",
  scenarioFactory: "Производство на заводе",
  scenarioFactoryDesc:
    "Серийное производство, стабильный выпуск и экономичные операции",
  scenarioAdvertising: "Рекламное производство",
  scenarioAdvertisingDesc:
    "Вывески, дисплейные материалы и материалы для мероприятий",
  industries: "Отраслевые применения",
  industriesDesc:
    "Решения цифровой струйной печати для цветной печати в различных отраслях.",
  applicationsTitle:
    "Универсальные применения материалов и цветов для повседневных и коммерческих нужд.",
  applicationsDesc:
    "УФ-печатное оборудование YONGYUAN разработано для широкого спектра материалов и технологических сценариев, обеспечивая персонализацию и крупномасштабное производство.",
  casesHeroDesc:
    "Более 1200 отраслевых применений и десятки тысяч материалов для печати — цифровые печатные решения для разных видов бизнеса.",
  casesBreadcrumbHome: "Главная",
  casesBreadcrumbCenter: "Примеры применения",
  casesEmpty: "В этой категории пока нет примеров применения.",
  customerStoriesTitle: "Нам доверяют клиенты по всему миру",
  customerStoriesSubtitle:
    "Реальные установки, реальные клиенты, реальный печатный бизнес в 172 странах.",
  customerStoriesStat1Value: "53 000+",
  customerStoriesStat1Label: "Поставлено принтеров",
  customerStoriesStat2Value: "172+",
  customerStoriesStat2Label: "Стран обслуживания",
  customerStoriesStat3Value: "23+",
  customerStoriesStat3Label: "Лет опыта",
  customerStoriesStat4Value: "24/7",
  customerStoriesStat4Label: "Техническая поддержка",
  customerStoriesPlaceholder: "Добавить фото клиента",
  customerStoriesPhotoAlt: "Клиент YONGYUAN с принтером",
  servicePartnerTitle:
    "Познакомьтесь с сервисной командой YONGYUAN �?вашим творческим партнёром",
  servicePartnerDesc:
    "Глобальная сервисная сеть и профессиональная система поддержки для защиты производительности вашего оборудования и роста бизнеса.",
  serviceSupportTitle: "Стандартная поддержка",
  serviceSupportDesc:
    "Руководство по установке, базовое обучение и ежедневная помощь для надёжной работы оборудования.",
  servicePresaleTitle: "Предпродажная демонстрация и консультация",
  servicePresaleDesc:
    "Демонстрации решений и рекомендации моделей, адаптированные к вашим сценариям применения и требованиям к мощности.",
  serviceLifetimeTitle: "Пожизненная техническая поддержка",
  serviceLifetimeDesc:
    "Постоянная техническая поддержка и сопровождение процессов для долгосрочного развития вашего бизнеса.",
  serviceCareTitle: "Перейти на YONGYUAN Care",
  serviceCareDamageTitle: "Защита от случайных повреждений",
  serviceCareDamageDesc:
    "Более комплексный план защиты для снижения убытков от непредвиденных инцидентов.",
  serviceCareExchangeTitle: "Быстрый обмен",
  serviceCareExchangeDesc:
    "Приоритетный быстрый обмен при соответствии условиям для ускорения возврата капитала.",
  viewProduct: "Смотреть продукцию",
  learnMore: "Подробнее",
  catUv: "УФ планшетный принтер",
  catCylinder: "Цилиндрический принтер",
  catCrystal: "Принтер кристальных этикеток",
  catDtf: "DTF принтер",
  catDtg: "DTG принтер",
  companyName: "Shenzhen Yongyuan Technology Co., Ltd.",
  phone: "Телефон: 17748697567 Менеджер Тан",
  email: "Email: sales@yongyuanprinter.com",
  copyright:
    "Copyright © 2012-2026 Shenzhen Yongyuan Technology Co., Ltd. Все права защищены",
  productsHeroTitle: "Продукция",
  productsHeroDesc:
    "Полная линейка УФ планшетного, цилиндрического, кристаллического, DTF и DTG оборудования для различных потребностей в мощности и применении.",
  productsBreadcrumbHome: "Главная",
  productsBreadcrumbCenter: "Продукция",
  productsEmpty: "Продукция в этой категории скоро появится.",
  productsQuoteTitle: "Запросить решение и коммерческое предложение",
  productsQuoteDesc:
    "Расскажите о ваших сценариях применения и требованиях к мощности �?мы порекомендуем подходящее оборудование.",
  productsContact: "Связаться с нами",
  aboutHeroTitle: "О Yongyuan",
  aboutHeroDesc:
    "23 лет, посвящённых исследованиям, разработке и производству УФ-печатного оборудования",
  productA23Subtitle: "Настольный 6-цветный интеллектуальный УФ-принтер",
  productA23Feature1: "Формат печати A4",
  productA23Feature2: "Интеллектуальная система подачи чернил",
  productA23Feature3: "Инфракрасное автоматическое определение высоты",
  productA35Subtitle: "Настольный 6-цветный интеллектуальный УФ-принтер",
  productA35Feature1: "Формат печати A3+",
  productA35Feature2: "Интеллектуальная система подачи чернил",
  productA35Feature3: "Инфракрасное автоматическое определение высоты",
  productA43Subtitle: "Флагманский 8-цветный интеллектуальный УФ-принтер",
  productA43Feature1: "Формат печати A3",
  productA43Feature2: "Несколько конфигураций печатающих головок",
  productA43Feature3: "Интеллектуальная система подачи чернил",
  productA46Subtitle: "Флагманский 8-цветный интеллектуальный УФ-принтер",
  productA46Feature1: "Формат печати A2",
  productA46Feature2: "Несколько конфигураций печатающих головок",
  productA46Feature3: "Интеллектуальная система подачи чернил",
  productA57Subtitle: "Флагманский 8-цветный интеллектуальный УФ-принтер",
  productA57Feature1: "Формат печати A2+",
  productA57Feature2: "Несколько конфигураций печатающих головок",
  productA57Feature3: "Интеллектуальная система подачи чернил",
  productA69Subtitle: "Флагманский 8-цветный интеллектуальный УФ-принтер",
  productA69Feature1: "Формат печати A1",
  productA69Feature2: "Несколько конфигураций печатающих головок",
  productA69Feature3: "Интеллектуальная система подачи чернил",
  productA1216Subtitle: "Флагманский широкоформатный УФ планшетный принтер",
  productA1216Feature1: "Формат печати 1200×1600cm",
  productA1216Feature2: "Несколько конфигураций печатающих головок",
  productA1216Feature3: "Система визуального позиционирования",
  productA2513Subtitle: "Флагманский широкоформатный УФ планшетный принтер",
  productA2513Feature1: "Формат печати 2500×1300cm",
  productA2513Feature2: "Несколько конфигураций печатающих головок",
  productA2513Feature3: "Система визуального позиционирования",
  productCylinderElfSubtitle: "Высокоскоростной цилиндрический принтер 360°",
  productCylinderElfFeature1: "Печать 360°",
  productCylinderElfFeature2: "Персонализация чашек и бутылок",
  productCylinderElfFeature3: "Быстрая смена приспособлений",
  productCupPlusSubtitle: "Решение для печати на чашках и бутылках разных размеров",
  productCupPlusFeature1: "Приспособления разных размеров",
  productCupPlusFeature2: "Высокая производительность",
  productCupPlusFeature3: "Стабильный выпуск",
  productCrystal60Subtitle: "Комплексная система печати и тиснения кристаллических этикеток",
  productCrystal60Feature1: "Ширина 60cm",
  productCrystal60Feature2: "Интеграция печати и тиснения",
  productCrystal60Feature3: "Эффективная система намотки",
  productCrystalC60UltraFeature1: "Ширина 60 см",
  productCrystalC60UltraFeature2: "Золото/серебро/3D силиконовые этикетки",
  productCrystalC60UltraFeature3: "Массовое производство",
  productCrystal30Subtitle: "Компактный высокоточный принтер кристаллических этикеток",
  productCrystal30Feature1: "Компактная точная печать",
  productCrystal30Feature2: "Простое управление",
  productCrystal30Feature3: "Индивидуальная персонализация",
  productDtf60Subtitle: "DTF принтер с белыми чернилами",
  productDtf60Feature1: "DTF трансфер с белыми чернилами",
  productDtf60Feature2: "Богатые цветовые слои",
  productDtf60Feature3: "Аксессуары для одежды",
  productDtfF20Subtitle: "Самый компактный настольный DTF-принтер с белыми чернилами в отрасли",
  productDtfF20Feature1: "Формат A4",
  productDtfF20Feature2: "Мелкосерийная персонализация",
  productDtfF20Feature3: "Интеллектуальная система подачи чернил",
  productDtfF30Subtitle: "Настольный DTF-принтер с белыми чернилами",
  productDtfF30Feature1: "Формат A3",
  productDtfF30Feature2: "Одна головка, ручная/автоматическая версия",
  productDtfF30Feature3: "Интеллектуальная система подачи чернил",
  productDtfF30ProSubtitle: "DTF-принтер с белыми чернилами",
  productDtfF30ProFeature1: "Формат A3",
  productDtfF30ProFeature2: "Двухголовая конфигурация с автоматическим сматыванием плёнки",
  productDtfF30ProFeature3: "Интеллектуальная система подачи чернил",
  productDtfF33Subtitle: "DTF-принтер с белыми чернилами",
  productDtfF33Feature1: "Формат A3",
  productDtfF33Feature2: "Одна головка, ручная/автоматическая версия",
  productDtfF33Feature3: "Интеллектуальная система подачи чернил",
  productDtfF70ProSubtitle: "Широкоформатный DTF-принтер 70 см с белыми чернилами",
  productDtfF70ProFeature1: "Формат A2",
  productDtfF70ProFeature2: "Варианты с 2�? печатающими головками",
  productDtfF70ProFeature3: "Автоматическая система подачи и вывода",
  productDtfF70ProFeature4: "Интеллектуальный режим возобновления печати",
  productDtf30Subtitle: "Компактный DTF принтер с белыми чернилами",
  productDtf30Feature1: "Мелкосерийная персонализация",
  productDtf30Feature2: "Точная цветопередача",
  productDtf30Feature3: "Прост в использовании",
  productDtgPrintSubtitle: "Цифровой прямой принтер для текстиля",
  productDtgPrintFeature1: "Прямая печать на разных материалах",
  productDtgPrintFeature2: "Высокая производительность",
  productDtgPrintFeature3: "Стабильный и долговечный",
  productDtg3250DSubtitle: "Единственная в отрасли модель 2-в-1 DTF и DTG",
  productDtg3250DFeature1: "Формат A3+",
  productDtg3250DFeature2: "Двухрежимная печать DTF и DTG",
  productDtg3250DFeature3: "Интеллектуальная система подачи чернил",
  productDtg3646TSubtitle: "DTG-принтер с двумя рабочими станциями",
  productDtg3646TFeature1: "Режим непрерывного производства",
  productDtg3646TFeature2: "Повышение производительности на 100%",
  productDtg3646TFeature3: "Интеллектуальная система подачи чернил",
  productDtgMaxSubtitle: "Промышленный цифровой DTG принтер",
  productDtgMaxFeature1: "Промышленная мощность",
  productDtgMaxFeature2: "Стабильный и долговечный",
  productDtgMaxFeature3: "Непрерывная работа",
  app01Title: "Чехлы для телефонов",
  app02Title: "Мячи для гольфа",
  app03Title: "Каменные таблички",
  app04Title: "Шариковые ручки",
  app05Title: "Футляры для очков",
  app06Title: "Деревянные гравюры",
  app07Title: "Банки с напитками",
  app08Title: "Клавиатуры",
  app09Title: "Термокружки",
  app10Title: "Багаж",
  app11Title: "Акриловые изделия",
  app12Title: "Блокноты",
  app13Title: "Значки",
  app14Title: "Кожаные визитницы",
  app15Title: "Жетоны",
  app16Title: "Стеклянное искусство",
  appDtgCase01: "Футболки",
  appDtgCase02: "Худи",
  regionCn: "Китай",
  regionUs: "США",
  regionGb: "Великобритания",
  regionDe: "Германия",
  regionAe: "ОАЭ",
  regionIn: "Индия",
  regionJp: "Япония",
  regionVn: "Вьетнам",
  regionBr: "Бразилия",
  regionAu: "Австралия",

  // synced from en
    uiClose: "Close",
    carouselPrev: "Previous product",
    carouselNext: "Next product",
    heroSlidePrev: "Previous slide",
    heroSlideNext: "Next slide",
    heroSlideDot: "Go to slide {n}",
    customerStoriesTrustedTitle: "Trusted Worldwide",
    customerStoriesBadge: "{count} international customer photos showcased",
    customerStoryCountryUsaNewYork: "New York, USA",
    customerStoryCountryGermany: "Germany",
    customerStoryCountryThailand: "Thailand",
    customerStoryCountrySpain: "Spain",
    customerStoryCountryBrazil: "Brazil",
    customerStoryCountryAustralia: "Australia",
    customerStoryCountrySaudiArabia: "Saudi Arabia",
    customerStoryCountrySingapore: "Singapore",
    customerStoryCountryKorea: "South Korea",
    customerStoryCountryIsrael: "Israel",
    customerStoryCountryKazakhstan: "Kazakhstan",
    customerStoryCountryMexico: "Mexico",
    customerStoryCountryArgentina: "Argentina",
    customerStoryCountryPhilippines: "Philippines",
    customerStoryCountryIndonesia: "Indonesia",
    customerStoryCountryNetherlands: "Netherlands",
    customerStoryCountrySweden: "Sweden",
    customerStoryCountrySouthAfrica: "South Africa",
    customerStoryCountryMalaysia: "Malaysia",
    customerStoryCountryTaiwan: "Taiwan",
    customerStoryCountryUsa: "United States",
    customerStoryCaption01: "USA�?090 UV Printer",
    customerStoryCaption02: "Germany｜F33 DTF Printer",
    customerStoryCaption03: "Thailand�?250 UV Printer",
    customerStoryCaption04: "Spain�?250 UV Printer",
    customerStoryCaption05: "Brazil�?030 UV Printer",
    customerStoryCaption06: "Australia｜F33 DTF Printer",
    customerStoryCaption07: "Saudi Arabia�?030 UV Printer",
    customerStoryCaption08: "Singapore｜F33 DTF Printer",
    customerStoryCaption09: "South Korea｜F33 DTF Printer",
    customerStoryCaption10: "Israel｜UVC33 DTF Printer",
    customerStoryCaption11: "Kazakhstan�?030 UV Printer",
    customerStoryCaption12: "Mexico�?060 UV Printer",
    customerStoryCaption13: "Argentina�?060 UV Printer",
    customerStoryCaption14: "Philippines�?090 UV Printer",
    customerStoryCaption15: "Indonesia�?030 UV Printer",
    customerStoryCaption16: "Netherlands�?030 UV Printer",
    customerStoryCaption17: "Sweden�?060 UV Printer",
    customerStoryCaption18: "Germany�?030 UV Printer",
    customerStoryCaption19: "South Africa�?030 UV Printer",
    customerStoryCaption20: "Malaysia｜F33 DTF Printer",
    customerStoryCaption21: "Taiwan｜UVC33 DTF Printer",
    customerStoryCaption22: "USA｜F70Pro DTF Printer",
    customerStoryCaption23: "USA�?513 UV Printer",
    customerStoryCaption24: "USA�?090 UV Printer",
    customerStoryCaption25: "USA�?030 UV Printer",
    customerStoryCaption26: "USA�?250 UV Printer",
    customerStoryCaption27: "South Korea�?060 UV Printer",
    customerStoryCaption28: "Netherlands�?060 UV Printer",
    catUvNav: "UV Flatbed",
    catCylinderNav: "Cylindrical",
    catCrystalNav: "Crystal Label",
    catDtfNav: "DTF",
    catDtgNav: "DTG",
    productA3220Subtitle: "Ultra Wide-Format Industrial UV Flatbed Solution",
    productA3220Feature1: "320×200cm Print Format",
    productA3220Feature2: "Visual Positioning System",
    productA3220Feature3: "Continuous Batch Production",
    productCrystal60UltraSubtitle: "Flagship Crystal Label Printing Solution",
    cityShanghai: "Shanghai",
    cityShenzhen: "Shenzhen",
    cityDetroit: "Detroit",
    cityManchester: "Manchester",
    cityStuttgart: "Stuttgart",
    cityDubai: "Dubai",
    cityPune: "Pune",
    cityOsaka: "Osaka",
    cityHoChiMinh: "Ho Chi Minh City",
    citySaoPaulo: "São Paulo",
    cityMelbourne: "Melbourne",
};
